// JsFromRoutes CacheKey d9f81a098c5d9b09fdb1477c7034fc43
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  verifyDisable: definePathHelper('post', '/users/disable_otp'),
  verifyEnable: definePathHelper('post', '/users/enable_otp'),
}
